import { render, staticRenderFns } from "./entryFile.vue?vue&type=template&id=381c1fda&scoped=true"
import script from "./entryFile.vue?vue&type=script&lang=js"
export * from "./entryFile.vue?vue&type=script&lang=js"
import style0 from "./entryFile.vue?vue&type=style&index=0&id=381c1fda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c1fda",
  null
  
)

export default component.exports